"use strict";
// (C) 2019-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetadataObjectBuilder = void 0;
var tslib_1 = require("tslib");
var builder_1 = require("../builder");
/**
 * Metadata object builder
 * See {@link Builder}
 *
 * @beta
 */
var MetadataObjectBuilder = /** @class */ (function (_super) {
    tslib_1.__extends(MetadataObjectBuilder, _super);
    function MetadataObjectBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MetadataObjectBuilder.prototype.title = function (title) {
        this.item.title = title;
        return this;
    };
    MetadataObjectBuilder.prototype.description = function (description) {
        this.item.description = description;
        return this;
    };
    MetadataObjectBuilder.prototype.id = function (identifier) {
        this.item.id = identifier;
        return this;
    };
    MetadataObjectBuilder.prototype.uri = function (uri) {
        this.item.uri = uri;
        return this;
    };
    MetadataObjectBuilder.prototype.unlisted = function (value) {
        this.item.unlisted = value;
        return this;
    };
    MetadataObjectBuilder.prototype.production = function (isProduction) {
        this.item.production = isProduction;
        return this;
    };
    MetadataObjectBuilder.prototype.deprecated = function (isDeprecated) {
        this.item.deprecated = isDeprecated;
        return this;
    };
    return MetadataObjectBuilder;
}(builder_1.Builder));
exports.MetadataObjectBuilder = MetadataObjectBuilder;
//# sourceMappingURL=factory.js.map